// 主题模块上下文

import { createContext, useContext, ReactNode } from "react";
import { useThemeData } from "../stores";
import { themeService } from "../services";
import { useBaseCache } from "../../base/contexts";

// Context类型定义
interface ThemeContextType {
  // 主题数据
  themeData: ReturnType<typeof useThemeData>;
  // 主题服务
  themeService: typeof themeService;
  // 基础缓存
  cache: ReturnType<typeof useBaseCache>;
}

// 创建Context
const ThemeContext = createContext<ThemeContextType | null>(null);

// Provider Props
interface ThemeContextProviderProps {
  children: ReactNode;
}

// Provider组件
export function ThemeContextProvider({ children }: ThemeContextProviderProps) {
  const themeData = useThemeData();
  const cache = useBaseCache();

  const value: ThemeContextType = {
    themeData,
    themeService,
    cache,
  };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}

// Hook
export function useThemeContext(): ThemeContextType {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeContext must be used within ThemeContextProvider");
  }
  return context;
}
